module.exports = __webpack_public_path__ + "static/Stories From The Eastern West-6cb885a1d90c2e60ed60fe5e02d6a0ad.png";